export default {
  Expert: {
    fields: {
      inbox: {
        merge: false,
      },
    },
  },
};
